var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-view product-checkout mt-0"},[_c('e-commerce-checkout-step-cart-products'),_c('e-commerce-checkout-price-details',{on:{"next-step":_vm.nextStep}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }